import { createContext, useState, useEffect, useCallback, useContext } from 'react';
import api from './api/axiosInstance';
import { UserContext } from './UserContext';
import { isAdminType } from './utils/roleUtils.js';

export const TicketCountContext = createContext();

export const TicketCountProvider = ({ children }) => {
  const [ticketCount, setTicketCount] = useState(0);

  // 🟢 new: get current user
  const { user } = useContext(UserContext); // ✅

  const fetchTicketCount = useCallback(async () => {
    const token = localStorage.getItem('token');

    // ✅ only fetch if logged in AND admin type
    if (!user || !token) return;
    if (!isAdminType(user.role)) return;

    try {
      const res = await api.get(`/api/tickets`);
      const unarchived = res.data.filter((t) => !t.isArchived);
      setTicketCount(unarchived.length);
    } catch (err) {
      console.error('Failed to fetch ticket count', err);
    }
  }, [user]); // ✅ depend on user

  useEffect(() => {
    fetchTicketCount();
  }, [fetchTicketCount]);

  return (
    <TicketCountContext.Provider value={{ ticketCount, refreshTicketCount: fetchTicketCount }}>
      {children}
    </TicketCountContext.Provider>
  );
};
